import { Inject } from '@odinjs/odin';
import { ButtonAPI, FormAPI, ModalService, PanelAPI, TextAreaAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnBeforeSubmit, OnCancel, OnKeyUp } from '@philips-internal/oswald-ui-core/lib/client';

import { AbortableSubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

import BaseController from '../../BaseController';
import ClinicalNotesService from '../clinical-note-service';
import {CustomDynamicButtonAPI} from '@philips-emr/health-professional-components/src/components';

const MAX_LENGTH_JUSTIFICATION = 500;

@Controller({ component: 'layout-patient-evolution', fragment: 'patient-evolution-inactivation' })
class PatientEvolutionInactivationController extends BaseController {

  @Inject('justification-text-area')
    justificationTextArea!: TextAreaAPI;

  @Inject('inactivation-justification-button')
    buttonInactivate!: ButtonAPI;

  @Inject('panel-loader')
    panelLoader!: PanelAPI;

  @Inject('justification-form')
    justificationForm!: FormAPI;

  @Inject('inactivate-custom-dynamic-button')
    inactivateDynamicButton!: CustomDynamicButtonAPI;

  close(): void {
    ModalService.close('patient-evolution-inactivation');
  }

  goClinicalNoteList(): void {
    this.close();
    applicationContext.popNavigationItem();
  }

  justificationTextIsEmpty(): boolean {
    const justificationTextArea = this.justificationTextArea.getValue().trim();
    return !justificationTextArea || justificationTextArea.length === 0;
  }

  justificationTextLength(): number {
    const justificationTextArea = this.justificationTextArea.getValue().trim();
    return justificationTextArea ? justificationTextArea.length : 0;
  }

  @OnKeyUp({ target: 'justification-text-area' })
  onJustificationTextKeyUp(): void {
    this.inactivateDynamicButton.setEnabled('inactivateButtonAction', !this.justificationTextIsEmpty())
  }

  @OnCancel({ target: 'justification-form' })
  onCancelForm(): void {
    this.close();
  }

  @OnBeforeSubmit({ target: 'justification-form' })
  onBeforeSubmitForm(event: AbortableSubmitEvent): void {
    event.abort(this.handleInactivateClick());
  }

  async handleInactivateClick(): Promise<boolean> {
    const isValid = this.justificationForm.validate()
    if (!isValid) {
      return true;
    }

    let inactivated = true;

    if (this.justificationTextLength() <= MAX_LENGTH_JUSTIFICATION) {

      const { cdEvolucao, patientId, encounterId } = this.historyService.getCurrentRouteParams();
      const dsJustificativa = this.justificationTextArea.getValue();

      const evolutionId = cdEvolucao as number;
      const encountersId = encounterId as number;
      const patientsId = patientId as number;

      this.panelLoader.setVisible(true);

      const cnService = new ClinicalNotesService(this);

      try {

        inactivated = await cnService.inactivate(patientsId, encountersId, evolutionId, dsJustificativa);

        if (inactivated) {

          cnService.showMessageDialog(
            'title.disable-record',
            'patient-evolution.successfully-inactivated-message',
            () => { this.goClinicalNoteList() }
          );

        } else {

          cnService.showMessageDialog(
            'patient-evolution.error-message',
            '',
            () => { this.goClinicalNoteList() }
          );

        }
      } catch (error: any) {

        cnService.showMessageDialog(
          'patient-evolution.error-message',
          error?.body as string,
          () => { this.goClinicalNoteList() },
        );
      }
    }

    return inactivated;
  }
}

export default PatientEvolutionInactivationController;
